module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-2-380-6eac41209841fece261fba014c0f0b38.png";